import { useEffect } from 'react';

export const loadGoogleMapsScript = (apiKey:string) => {
  if (!document.querySelector(`script[src="https://aaaaaamaps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places"]`)) {
    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places`;
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);
  }
};
